enum EnterpriseBuilderScreenStep {
    Dashboard = 'Dashboard',
    Enterprise = 'Enterprise',
    ResourceCategories = 'ResourceCategories',
    Floors = 'Floors',
    ResourceOverviewGrid = 'ResourceOverviewGrid',
    Resources = 'Resources',
}

export default EnterpriseBuilderScreenStep;
